import jsyaml from 'js-yaml';

// Codemirrror yaml plugin expects to find it in window/globals.
window.jsyaml = jsyaml;
